import { render, staticRenderFns } from "./index.vue?vue&type=template&id=be9ddfb0&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\progect\\guowai\\ex_express_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be9ddfb0')) {
      api.createRecord('be9ddfb0', component.options)
    } else {
      api.reload('be9ddfb0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=be9ddfb0&", function () {
      api.rerender('be9ddfb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/header-aside/components/header-base-url/index.vue"
export default component.exports